import { jsx as f } from "react/jsx-runtime";
import { useMemo as l } from "react";
import { useAuth as I } from "@dcentralexpedientedigital/fe-shared/hooks/use-auth";
import { PlatformApiContext as T } from "./create-provider.js";
const P = ({ baseUrl: s, path: c, params: o }) => {
  const t = new URL(c, s);
  if (o)
    for (const [a, r] of Object.entries(o))
      r !== void 0 && t.searchParams.set(a, String(r));
  return t.toString();
}, b = async (s) => {
  try {
    const c = await s.json();
    if (c !== null && typeof c == "object" && "error" in c)
      return c;
  } catch {
  }
  return {
    error: {
      code: `HTTP-${s.status}`,
      statusCode: s.status,
      message: s.statusText || "Unknown error"
    },
    requestId: ""
  };
}, d = async ({
  baseUrl: s,
  method: c,
  path: o,
  token: t,
  tenantId: a,
  options: r
}) => {
  const { params: u, body: i, hasIdempotencyKey: n, ...e } = r ?? {}, p = P({ baseUrl: s, path: o, params: u }), y = Object.fromEntries(new Headers(e.headers).entries()), h = {
    "Content-Type": "application/json",
    "X-Tenant-ID": a,
    ...t ? { Authorization: `Bearer ${t}` } : {},
    ...n ? { "Idempotency-Key": crypto.randomUUID() } : {},
    ...y
  }, m = await fetch(p, {
    method: c,
    ...e,
    headers: h,
    body: i ? JSON.stringify(i) : void 0
  });
  if (!m.ok)
    throw await b(m);
  return m.json();
}, E = ({
  children: s,
  config: c
}) => {
  var i;
  const { baseUrl: o, tenantId: t } = c, { auth: a } = I(), r = ((i = a == null ? void 0 : a.user) == null ? void 0 : i.access_token) ?? null, u = l(
    () => ({
      get: (n, e) => d({ baseUrl: o, method: "GET", path: n, token: r, tenantId: t, options: e }),
      post: (n, e) => d({
        baseUrl: o,
        method: "POST",
        path: n,
        token: r,
        tenantId: t,
        options: { ...e, hasIdempotencyKey: !0 }
      }),
      put: (n, e) => d({
        baseUrl: o,
        method: "PUT",
        path: n,
        token: r,
        tenantId: t,
        options: { ...e, hasIdempotencyKey: !0 }
      }),
      patch: (n, e) => d({
        baseUrl: o,
        method: "PATCH",
        path: n,
        token: r,
        tenantId: t,
        options: { ...e, hasIdempotencyKey: !0 }
      }),
      delete: (n, e) => d({
        baseUrl: o,
        method: "DELETE",
        path: n,
        token: r,
        tenantId: t,
        options: { ...e, hasIdempotencyKey: !0 }
      })
    }),
    [o, r, t]
  );
  return /* @__PURE__ */ f(T.Provider, { value: u, children: s });
};
export {
  E as PlatformApiProvider
};
